<template>
    <div class="list-img">
        <div class="li" v-if="Create.includes(role) || adminQnumber==userId">
            <img src="./img/hrob01.png" width="100%" alt=""/>
            <div class="position" @click="createList">
                <div class="title">Offer Proposal</div>
                <a class="abt" href="javascript:void(0)">Create</a>
            </div>
        </div>
        <div class="li"  v-if="Create.includes(role) || adminQnumber==userId">
            <img src="./img/hrob02.png" width="100%" alt=""/>
            <div class="position">
                <div class="title">Offer Proposal</div>
                <a class="abt" href="/application/on_boarding/application-list/HROBProposal?parentId=2c2c8082828fae12018290e32842028d&code=HROBProposal&openMode&pcUrl&queryCode=&HomePageMessage=">VIEW</a> 
            </div>
        </div>
        <div class="li"  v-if="Application.includes(role) || adminQnumber==userId">
            <img src="./img/hrob03.png" width="100%" alt=""/>
            <div class="position">
                <div class="title">All Application List</div>
                <a class="abt" href="/application/on_boarding/application-list/allApplicationList1">VIEW</a> 
            </div>
        </div>
        <div class="li" v-if="Employee.includes(role) || adminQnumber==userId">
            <img src="./img/hrob03.png" width="100%" alt=""/>
            <div class="position">
                <div class="title">New Employee List For SSC</div>
                <a class="abt" href="/application/on_boarding/application-list/AllApplicationListfor">VIEW</a> 
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios";
export default{
    data(){
        return {
            role:'',
            adminQnumber:'QXZ2QO7',
            userId:'',
            Employee:['IBM'],
            Application:['TR','SRHRM'],
            Create:['HRBP','TR','SRHRM','Admin']
        }
    },
    async mounted(){
        const user = JSON.parse(sessionStorage.getItem('user'));
        const data =  await axios.get('/api/findApprover/getUserInfoById?userId='+user.id);
        this.userId = user.userId;
        const UserList = await axios.post('/api/jobtran/queryTable',{
            "schemacode":"userList",
            data:{
                qNumber:user.userId
            }
        });
        console.log(UserList)
        if(UserList.data && UserList.data.length){
            this.role = UserList.data[0].role
        }
    },
    methods:{
        createList(data) {
            window.open(
            `/application/on_boarding/application-list/HROBProposal?HomePageMessage=1`,
            "_self"
            );
            // window.open(
            //   `/form/detail?schemaCode=${data.appchirdenCode}&sheetCode=null&queryCode=${data.appchirdenCode}`
            // );
        }
    }
}
</script>
<style lang="less" scoped>
    .list-img{
        display: flex;
        flex-flow: wrap;
        justify-content: space-between;
        padding:20px 20px 0 ;
        box-sizing: border-box;
        .li{
            width: 50%;
            position: relative;
            .position{
                position: absolute;
                width: 100%;
                height: 100%;
                z-index: 10;
                top: 0;
                left: 0;
                padding: 30px;
                font-weight: bold;
                .title{
                    margin-bottom: 30px;
                    font-size: 18px;
                }
                a{
                    font-size: 12px;
                    background: #1c69d4;
                    color: #fff;
                    padding: 5px 40px;
                }
            }
        }
    }
</style>